import { patientDiagnosisService } from '@/services/patient-diagnosis-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { denormalize, normalize } from 'normalizr'
import { schemas } from '@/store/schemas'

export const mutations = {
  ['SET_PATIENT_DIAGNOSES'](state, diagnoses) {
    const result = normalize(diagnoses, schemas.patientDiagnosisList)
    state.patientDiagnoses = result.entities.patientDiagnoses
    state.diagnoses = { ...state.diagnoses, ...result.entities.diagnoses }
    state.diagnosisHistologies = {
      ...state.diagnosisHistologies,
      ...result.entities.diagnosisHistologies
    }
    state.diagnosisSites = { ...state.diagnosisSites, ...result.entities.diagnosisSites }
    state.diagnosisStages = { ...state.diagnosisStages, ...result.entities.diagnosisStages }
    state.diagnosisGrades = { ...state.diagnosisGrades, ...result.entities.diagnosisGrades }
    state.metastases = { ...state.metastases, ...result.entities.metastases }
  }
}

export const actions = {
  async ['CREATE_PATIENT_DIAGNOSIS']({ dispatch }, { diagnosis }) {
    await patientDiagnosisService.create(MyActiveOrganization.id, diagnosis)
    dispatch('GET_PATIENT_DIAGNOSES', { patientId: diagnosis.patient.id })
  },

  async ['UPDATE_PATIENT_DIAGNOSIS']({ dispatch }, { diagnosis }) {
    await patientDiagnosisService.create(MyActiveOrganization.id, diagnosis)
    dispatch('GET_PATIENT_DIAGNOSES', { patientId: diagnosis.patient.id })
  },

  async ['DELETE_PATIENT_DIAGNOSIS']({ dispatch }, { diagnosis }) {
    await patientDiagnosisService.delete(MyActiveOrganization.id, diagnosis.id)
    dispatch('GET_PATIENT_DIAGNOSES', { patientId: diagnosis.patient.id })
  },

  async ['GET_PATIENT_DIAGNOSES']({ commit }, { patientId }) {
    const response = await patientDiagnosisService.get(MyActiveOrganization.id, patientId)
    commit('SET_PATIENT_DIAGNOSES', response.data)
  }
}

export const getters = {
  getDenormalizedPatientDiagnosis: (state, getters) => patientDiagnosisId => {
    return denormalize(patientDiagnosisId, schemas.patientDiagnosis, getters.getNormalizedState())
  }
}
